import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-059184f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "display-2 font-Pretendar cola-color fw-bold mt-3 text-30 text-74" }, " 자주 묻는 질문 ", -1))
const _hoisted_2 = { class: "accordion-container font-Pretendar" }
const _hoisted_3 = { class: "tab-headers" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = { class: "questions-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "question-text text-12 text-35" }
const _hoisted_9 = { class: "toggle-icon" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<svg class=\"d-none d-sm-block\" width=\"40\" height=\"52\" viewBox=\"0 0 58 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-059184f4><g opacity=\"0.6\" data-v-059184f4><line x1=\"12\" y1=\"24\" x2=\"45\" y2=\"24\" stroke=\"#F40000\" stroke-width=\"3\" data-v-059184f4></line></g></svg><svg class=\"d-sm-none\" width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-059184f4><path d=\"M8 3.8938V14.1075\" stroke=\"#F40000\" stroke-width=\"0.851138\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-059184f4></path><path d=\"M2.89062 9.00061H13.1043\" stroke=\"#F40000\" stroke-width=\"0.851138\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-059184f4></path></svg>", 2)
const _hoisted_13 = [
  _hoisted_11
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg class=\"d-none d-sm-block\" width=\"40\" height=\"50\" viewBox=\"0 0 58 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-059184f4><path d=\"M29 7V43\" stroke=\"#F40000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-059184f4></path><path d=\"M11 25H47\" stroke=\"#F40000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-059184f4></path></svg><svg class=\"d-sm-none\" width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-059184f4><g opacity=\"0.6\" data-v-059184f4><line x1=\"3.17969\" y1=\"8.29172\" x2=\"12.5422\" y2=\"8.29172\" stroke=\"#F40000\" stroke-width=\"0.851138\" data-v-059184f4></line></g></svg>", 2)
const _hoisted_17 = [
  _hoisted_15
]
const _hoisted_18 = { class: "question-answer text-10 text-27" }

import { ref } from 'vue';
import HeadingBox from '../components/heading-box.vue';

interface Question {
  id: string;
  question: string;
  answer: string;
}

interface Tab {
  id: string;
  title: string;
  questions: Question[];
}

// Define props

export default /*#__PURE__*/_defineComponent({
  props: {
    tabs: null
  },
  setup(__props: any) {

const props = __props as {
  tabs: Tab[];
}



// State for managing accordion open/close
const activeTab = ref<string>(props.tabs[0]?.id || '');
const openQuestions = ref<Set<string>>(new Set());

const toggleQuestion = (questionId: string) => {
  if (openQuestions.value.has(questionId)) {
    openQuestions.value.delete(questionId);
  } else {
    openQuestions.value.add(questionId);
  }
};

const setActiveTab = (tabId: string) => {
  activeTab.value = tabId;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadingBox, { type: 'qna' }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.id,
            class: _normalizeClass([{ active: activeTab.value === tab.id }, "tab-header"]),
            onClick: ($event: any) => (setActiveTab(tab.id))
          }, _toDisplayString(tab.title), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: tab.id,
            class: "tab-panel"
          }, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.questions, (question) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: question.id,
                  class: "question-item"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{ active: openQuestions.value.has(question.id) }, "question-header"]),
                    onClick: ($event: any) => (toggleQuestion(question.id))
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(question.question), 1),
                    _createElementVNode("span", _hoisted_9, [
                      (openQuestions.value.has(question.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
                        : _createCommentVNode("", true),
                      (!openQuestions.value.has(question.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_7),
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", null, _toDisplayString(question.answer), 1)
                  ], 512), [
                    [_vShow, openQuestions.value.has(question.id)]
                  ])
                ]))
              }), 128))
            ])
          ])), [
            [_vShow, activeTab.value === tab.id]
          ])
        }), 128))
      ])
    ])
  ], 64))
}
}

})